import React, { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import constants from '../constants/Constants';
import LayoutStructure from '../components/Layout';
import { fronturls } from '../constants/FrontendUrls';
import { AdminRoute, StudentRoute, CommonRoute as CmnRoute } from './Helper';
import JsonResponseData from '../pages/admin/JsonInfo/JsonResponseData';
const InvalidBookCode = lazy(() => import('../pages/common/FAQs/InvalidBookCode'));
const AccessResources = lazy(() => import('../pages/common/FAQs/AccessResources'));
const FindAccessCode = lazy(() => import('../pages/common/FAQs/FindAccessCode'));
const UseMyCode = lazy(() => import('../pages/common/FAQs/UseMyCode'));
const DidNotReceiveRegistrationMail = lazy(() => import('../pages/common/FAQs/DidNotReceiveRegistrationMail'));
const NotReceivingMails = lazy(() => import('../pages/common/FAQs/NotReceivingMails'));
const ForgottenUsernamePassword = lazy(() => import('../pages/common/FAQs/ForgottenUsernamePassword'));
const AccAccessInfo = lazy(() => import('../pages/common/FAQs/AccAccessInfo'));
const CannotAccessOnlineResources = lazy(() => import('../pages/common/FAQs/CannotAccessOnlineResources'));
const CannotLoginAccount = lazy(() => import('../pages/common/FAQs/CannotLoginAccount'));
const UniversityListing = lazy(() => import('../pages/admin/Universities/UniversityListing'));
const AddUniversity = lazy(() => import('../pages/admin/Universities/AddUniversity'));
const CodesListing = lazy(() => import('../pages/admin/Codes/CodeListing'));
const Documents = lazy(() => import('../pages/admin/Documents/Documents'));
const DocView = lazy(() => import('../pages/common/DocView'));
const Policies = lazy(() => import('../pages/common/Policies'));
const Profile = lazy(() => import('../pages/common/Profile'));
const Feedback = lazy(() => import('../pages/student/Feedback'));
const ForgotPassword = lazy(() => import('../pages/common/ForgotPassword'));
const ResetPassword = lazy(() => import('../pages/common/ResetPassword'));
const Activation = lazy(() => import('../pages/common/Activation'));
const ResendActivation = lazy(() => import('../pages/student/ResendActivation'));
const AdminDashboard = lazy(() => import('../pages/admin/Dashboard'));
const Codes = lazy(() => import('../pages/admin/Codes/Codes'));
const Listing = lazy(() => import('../pages/common/Listing'));
const StudentDashboard = lazy(() => import('../pages/student/Dashboard'));
const EditUsers = lazy(() => import('../pages/common/EditUsers'));
const UserList = lazy(() => import('../pages/common/UserList'));
const VideoPreview = lazy(() => import('../pages/common/Video/VideoPreview'));
const Help = lazy(() => import('../pages/common/Help'));
const Acknowledgements = lazy(() => import('../pages/common/Acknowledgements'));
const Login = lazy(() => import('../pages/common/Login'));
const Registration = lazy(() => import('../pages/common/Registration'));
const ContactUs = lazy(() => import('../pages/common/ContactUs'));
const Home = lazy(() => import('../pages/common/Home'));
const PageNotFound = lazy(() => import('../pages/common/PageNotFound'));
const VideoEdit = lazy(() => import('../pages/admin/Video/VideoEdit'));
const ImageUpdate = lazy(() => import('../pages/admin/Images/ImageUpdate'));
const AnimationEdit = lazy(() => import('../pages/admin/Animation/AnimationEdit'));
const Settings = lazy(() => import('../pages/admin/Settings/Settings'));
const Crons = lazy(() => import('../pages/admin/Crons/Crons'));

const CommonRoute = (pathname, component) => {
  return <Route path={pathname} element={<Suspense>{component}</Suspense>} />
}

const routerBrowser = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Common routes */}
      <Route path={fronturls.ViewDocument} element={<DocView />} />
      <Route element={<LayoutStructure />}>

        <Route path="/" element={<Home />} />
        {CommonRoute(fronturls.Home, <Home />)}
        {CommonRoute(fronturls.Acknowledgements, <Acknowledgements />)}
        {CommonRoute(fronturls.Help, <Help />)}
        {CommonRoute(fronturls.StudentLogin, <Login />)}
        {CommonRoute(fronturls.AdminLogin, <Login />)}
        {CommonRoute(fronturls.Registration, <Registration />)}
        {CommonRoute(fronturls.ForgotPassword, <ForgotPassword />)}
        {CommonRoute(fronturls.ResetPassword, <ResetPassword />)}
        {CommonRoute(fronturls.Activation, <Activation />)}
        {CommonRoute(fronturls.ResendEmail, <ResendActivation />)}
        {CommonRoute(fronturls.ContactUs, <ContactUs />)}
        {CommonRoute(fronturls.InvalidBookCode, <InvalidBookCode />)}
        {CommonRoute(fronturls.AccessOnlineResources, <AccessResources />)}
        {CommonRoute(fronturls.FindAccessCode, <FindAccessCode />)}
        {CommonRoute(fronturls.UseMyCode, <UseMyCode />)}
        {CommonRoute(fronturls.DidNotReceiveMail, <DidNotReceiveRegistrationMail />)}
        {CommonRoute(fronturls.NotReceiveMails, <NotReceivingMails />)}
        {CommonRoute(fronturls.ForgottenUsernamePassword, <ForgottenUsernamePassword />)}
        {CommonRoute(fronturls.AccAccessInfo, <AccAccessInfo />)}
        {CommonRoute(fronturls.CannotAccessOnlineResources, <CannotAccessOnlineResources />)}
        {CommonRoute(fronturls.CannotLoginAccount, <CannotLoginAccount />)}
        {CommonRoute(fronturls.Policies, <Policies />)}
        <Route path={fronturls.MyProfile} element={<CmnRoute><Profile /></CmnRoute>} />
        <Route path="*" element={<PageNotFound />} />
        {/*  */}
        {/* Protected Routes for Students to be entered here */}
        <Route path={fronturls.Feedback} element={<StudentRoute><Feedback /></StudentRoute>} />
        <Route path={fronturls.StudentDashboard} element={<StudentRoute><StudentDashboard /></StudentRoute>} />
        {/*  */}

        <Route path={fronturls.AdminDashboard} element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path={fronturls.CodeGeneration} element={<AdminRoute><Codes /></AdminRoute>} />
        <Route path={fronturls.EditUser} element={<AdminRoute><EditUsers /></AdminRoute>} />
        <Route path={fronturls.AdminUsers} element={<AdminRoute><UserList /></AdminRoute>} />
        <Route path={fronturls.StudentUsers} element={<AdminRoute><UserList /></AdminRoute>} />
        <Route path={fronturls.ImageUpdate} element={<AdminRoute><ImageUpdate /></AdminRoute>} />
        <Route path={fronturls.UniversityListing} element={<AdminRoute><UniversityListing /></AdminRoute>} />
        <Route path={fronturls.AddUniversity} element={<AdminRoute><AddUniversity /></AdminRoute>} />
        <Route path={fronturls.VideoEdit} element={<AdminRoute><VideoEdit /></AdminRoute>} />
        <Route path={fronturls.AnimationEdit} element={<AdminRoute><AnimationEdit /></AdminRoute>} />
        <Route path={fronturls.CodesListing} element={<AdminRoute><CodesListing /></AdminRoute>} />
        <Route path={fronturls.Settings} element={<AdminRoute><Settings /></AdminRoute>} />
        <Route path={fronturls.CronActivity} element={<AdminRoute><Crons /></AdminRoute>} />
        <Route path={fronturls.Responsedata} element={<AdminRoute><JsonResponseData /></AdminRoute>} />

        {/* Common routes between student and admin */}
        <Route path={fronturls.Images} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.Videos} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.ResourceListing} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.Animation} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.VideoPreview} element={<CmnRoute><VideoPreview /></CmnRoute>} />
        <Route path={fronturls.AnimationPreview} element={<CmnRoute><VideoPreview /></CmnRoute>} />
        <Route path={fronturls.DocumentsListing} element={<AdminRoute><Documents /></AdminRoute>} />
      </Route>
    </>
  ),
  {
    basename: constants.BaseUrl,
  }
);
export default routerBrowser;
